module.exports = __webpack_public_path__ + "static/media/bsl-logo-mini-white.1f6ee8d3.png";